import { Metrika } from '../components/metrika';
import { Analytics } from '../components/analytics';

export function goals() {
    const metrika = new Metrika;
    const analytics = new Analytics;

    // Кнопа перезвонить в хедере и бургере
    let headerBtn = document.querySelector('[am-btn="header"][data-open="feedback"]');
    let burgerBtn = document.querySelector('[am-btn="burger"][data-open="feedback"]');

    function goal() {
        let self = this;

        metrika.reachGoal('CALLBACK_BUTTON_CLICK', this);
        analytics.event('CALLBACK_BUTTON_CLICK', this);

        setTimeout(function() {
            metrika.reachGoal('CALLBACK_FORM_SHOW', self);
            analytics.event('CALLBACK_FORM_SHOW', self);
        }, 300)
    }

    headerBtn.addEventListener('click', goal);
    burgerBtn.addEventListener('click', goal);


    // Блок этапы
    let stepsSection = document.querySelector('[am-section="steps"]');

    function stepsSectionVisible(item) {
        if (item === null) {
            return;
        }

        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight,
            windowScroll = document.documentElement.scrollTop || document.body.scrollTop,
            elemRect = windowScroll + item.getBoundingClientRect().top,
            windowCordStart = windowScroll,
            windowCordEnd = windowHeight + windowScroll,
            elemCordStart = windowScroll + item.getBoundingClientRect().top,
            elemCordEnd = elemRect + item.clientHeight;

        if (elemCordStart <= windowCordEnd && windowCordStart <= elemCordEnd) {
            metrika.reachGoal('SHOW_FORM_STEPS', stepsSection);
            analytics.event('SHOW_FORM_STEPS', stepsSection);
        }
    }

    stepsSectionVisible(stepsSection);
    window.addEventListener('scroll', function() {
        stepsSectionVisible(stepsSection);
    });
}